module.exports = __webpack_public_path__ + "img/box-4.a2b943ac.png";